import { PropsWithChildren, ReactNode } from 'react';
import {
  CircleAlert as CircleExclamationIcon,
  CircleCheckBig as CheckIcon,
  TriangleAlert as TriangleExclamationIcon,
  X as CloseIcon
} from 'lucide-react';

import { classNameList } from 'utils/property';
import { capitalize } from 'utils/string';
import styles from './MessageBar.module.scss';

interface IProps {
  title: string;
  description: string;
  variant?: 'neutral' | 'info' | 'success' | 'warning' | 'danger';
  showCloseAction?: boolean;
  fixed?: boolean;
}

export const MessageBar = ({
  title,
  description,
  variant = 'neutral',
  showCloseAction = true,
  fixed,
  children
}: IProps & PropsWithChildren): JSX.Element => {
  const VariantIcons = {
    neutral: <CircleExclamationIcon />,
    info: <CircleExclamationIcon />,
    success: <CheckIcon />,
    warning: <CircleExclamationIcon />,
    danger: <TriangleExclamationIcon />
  } as { [key: string]: ReactNode };

  return (
    <div className={classNameList(styles.messageBar, styles[`messageBar${capitalize(variant)}`], fixed && styles.fixed)}>
      <div className={styles.messageBarContent}>
        <div className={styles.messageBarContentIcon}>{VariantIcons[variant]}</div>
        <div
          className={classNameList(
            styles.messageBarContentText,
            !showCloseAction && styles.messageBarContentTextWithoutClose
          )}>
          <div className={styles.messageBarContentTextTitle}>{title}</div>
          <div className={styles.messageBarContentTextDescription}>{description}</div>
          {children}
        </div>
        {showCloseAction && (
          <div className={styles.messageBarContentClose}>
            <CloseIcon />
          </div>
        )}
      </div>
    </div>
  );
};
